import React from "react";
import { NavLink } from "react-router-dom";

export default function AIDrivenSoftware() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">AI-Driven Software Solutions</h1>
            <h5 className="text-muted">Empowering Your Business with Smart, Scalable & Multichannel Applications</h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/ai-technology-brain-background-vector-digital-transformation-concept_53876-112964.jpg"
              alt="AI-Driven Software"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose AI-Driven Software?</h2>
            <p>
              At <strong>Bytlas Intelligence</strong>, we build intelligent web applications tailored to enhance operational efficiency, optimize workflows, and enable data-driven decision-making. Our solutions are scalable, secure, and designed with your enterprise’s digital future in mind.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ AI-Powered Decision Engines</li>
              <li className="list-group-item">✅ Integrated Multichannel Communication (SMS, Email, WhatsApp, Chatbots)</li>
              <li className="list-group-item">✅ Scalable Cloud-Based Architecture</li>
              <li className="list-group-item">✅ Secure & Responsive Design</li>
            </ul>
          </div>
        </div>

        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Multi-Channel Communication</h3>
            <p>
              We integrate modern communication channels directly into your web platform—allowing your team and customers to interact through SMS, email, WhatsApp, and chatbot interfaces.
            </p>
            <p>
              Whether it's sending automated notifications, enabling live customer support, or marketing through campaigns, our solutions ensure a seamless, unified experience.
            </p>
          </div>
          <div className="col-md-6">
            <h3 className="text-secondary">Custom Features We Offer</h3>
            <ul>
              <li>🧠 NLP-based Chatbot Integration</li>
              <li>🔗 CRM & API Integrations</li>
              <li>📊 Real-time Analytics Dashboards</li>
              <li>🔒 Data Security with Role-based Access</li>
              <li>🌐 Progressive Web App (PWA) Capabilities</li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Get in Touch for a Free Demo
          </NavLink>
        </div>
      </div>
    </section>
  );
}
